import { render } from "./PersonalityType.vue?vue&type=template&id=1f16b472"
import script from "./PersonalityType.vue?vue&type=script&lang=js"
export * from "./PersonalityType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__